// tslint:disable-next-line: completed-docs
export function intercomPositionOnModalOpen(
  isMobileSummaryOpen: boolean,
): void {
  const intercomContainer = jQuery(document).find("#intercom-container");
  const intercomLauncher = jQuery(document).find(".intercom-launcher-frame");

  if (isMobileSummaryOpen) {
    intercomContainer.css("display", "none");
    intercomLauncher.css("margin-bottom", "330px");
  } else {
    intercomContainer.css("display", "block");
    intercomLauncher.css("margin-bottom", "0");
  }
}
